class Point {

    constructor (ctx, x, y, size = 5, lifespan = 2) {
        this.ctx = ctx;
        this.x = x;
        this.y = y;
        this.size = size;
        this.direction = Math.random() * Math.PI * 2;
        this.originLifespan = lifespan;
        this.lifespan = lifespan;
        this.opacity = 1;
        this.goingBrighter = false;
    }

    update () {
        this.x += Math.cos(this.direction);
        this.y += Math.sin(this.direction);
        this.lifespan -= 0.01;
        this.progress = this.lifespan / this.originLifespan;
    }

    once () {
        this.ctx.save();
        this.ctx.fillStyle = '#ffffff';
        this.ctx.beginPath();
        this.ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2, true);
        this.ctx.fill();
        this.ctx.closePath();
        this.ctx.restore();
    }

    draw () {
        this.update();
        this.ctx.save();
        this.ctx.translate(this.x, this.y);
        // this.opacity = this.goingBrighter ? this.opacity + 0.05 : this.opacity - 0.05;
        if (this.opacity >= 1) this.opacity -= 0.05;
        else if (this.opacity <= 0) this.opacity += 0.05;
        // if (this.opacity <= 0 || this.opacity >= 1) this.goingBrighter = !this.goingBrighter;
        this.ctx.globalAlpha = this.opacity;
        this.ctx.beginPath();
        this.ctx.fillStyle = '#ffffff';
        this.ctx.arc(0, 0, this.size, 0, Math.PI * 2, true);
        this.ctx.fill();
        this.ctx.closePath();
        this.ctx.restore();
    }

}

export default Point;
